module.exports = __webpack_public_path__ + "static/media/tone-picker-white.dec9ff192fc5a12dcdc0d462f760793065104b05c865c41ef7d8cf801ea84e19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tone-picker-white.png
// module id = 812
// module chunks = 204